import { SignOutIcon } from './icons.js'

/**
 * The shells' sign-out: an icon alone on the dark header, named for screen
 * readers and on hover. Every shell uses this one, so the action looks the
 * same wherever a person signs out.
 */
export function SignOutButton({ onSignOut }: { onSignOut: () => void }) {
  return (
    <button
      type="button"
      onClick={onSignOut}
      aria-label="Sign out"
      title="Sign out"
      className="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-white/75 transition-colors hover:bg-white/10 hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-coral"
    >
      <SignOutIcon />
    </button>
  )
}
